import React from "react";
import { useNavigate } from "react-router";

/**
 * 検索テーブル詳細ボタンコンポーネント
 * @param {string} title タイトル
 * @param {string} path パス
 * @class SearchTableButton
 */
export default function SearchTableButton({ title = "詳細", path }) {
  const navigate = useNavigate();
  /**
   * 指定されたパスに遷移する
   * @memberof SearchTableButton
   */
  const onClick = () => {
    if (path) navigate(path);
  };
  return (
    <button onClick={onClick} className="detail-btn">
      {title}
    </button>
  );
}
